'use client';

import { ErrorPageShell } from '@/components/error-page-shell';

// Keep error copy in sync with global-error.tsx (duplication is intentional —
// global-error replaces the root layout and cannot import shared modules)
export default function ErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return <ErrorPageShell error={error} reset={reset} logScope="root" variant="page" />;
}
